import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Divider } from 'antd';
import { MailOutlined, PhoneOutlined, EnvironmentOutlined, FacebookOutlined, TwitterOutlined, LinkedinOutlined, InstagramOutlined, YoutubeOutlined } from '@ant-design/icons';
import './ClientSupportInfo.css';

const { Text, Title } = Typography;

const ClientSupportInfo = ({ supportInfo, darkMode }) => {
    if (!supportInfo) {
        return null;
    }

    const hasAnyData = supportInfo.contact_email || 
                      supportInfo.contact_phone || 
                      supportInfo.address || 
                      (supportInfo.social_links && (
                          supportInfo.social_links.facebook ||
                          supportInfo.social_links.twitter ||
                          supportInfo.social_links.linkedin ||
                          supportInfo.social_links.instagram ||
                          supportInfo.social_links.youtube
                      ));

    if (!hasAnyData) {
        return null;
    }

    const socialLinks = supportInfo.social_links || {};

    return (
        <div className={`client-support-info ${darkMode ? 'dark-mode' : ''}`}>
            <Divider style={{ margin: '16px 0 12px 0', borderColor: darkMode ? '#434343' : '#e8e8e8' }} />
            <Title level={5} style={{ 
                marginBottom: '12px', 
                fontSize: '12px', 
                fontWeight: 600,
                color: darkMode ? '#fff' : '#595959',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
            }}>
                Support & Contact
            </Title>
            
            <div className="support-info-content">
                {supportInfo.contact_email && (
                    <div className="support-info-item">
                        <MailOutlined className="support-icon" />
                        <Text 
                            className="support-text"
                            ellipsis={{ tooltip: supportInfo.contact_email }}
                            style={{ color: darkMode ? '#bfbfbf' : '#8c8c8c' }}
                        >
                            {supportInfo.contact_email}
                        </Text>
                    </div>
                )}
                
                {supportInfo.contact_phone && (
                    <div className="support-info-item">
                        <PhoneOutlined className="support-icon" />
                        <Text 
                            className="support-text"
                            ellipsis={{ tooltip: supportInfo.contact_phone }}
                            style={{ color: darkMode ? '#bfbfbf' : '#8c8c8c' }}
                        >
                            {supportInfo.contact_phone}
                        </Text>
                    </div>
                )}
                
                {supportInfo.address && (
                    <div className="support-info-item">
                        <EnvironmentOutlined className="support-icon" />
                        <Text 
                            className="support-text support-address"
                            ellipsis={{ tooltip: supportInfo.address, rows: 2 }}
                            style={{ color: darkMode ? '#bfbfbf' : '#8c8c8c' }}
                        >
                            {supportInfo.address}
                        </Text>
                    </div>
                )}
                
                {(socialLinks.facebook || socialLinks.twitter || socialLinks.linkedin || socialLinks.instagram || socialLinks.youtube) && (
                    <div className="support-social-links">
                        {socialLinks.facebook && (
                            <a 
                                href={socialLinks.facebook} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="social-link"
                                title="Facebook"
                            >
                                <FacebookOutlined />
                            </a>
                        )}
                        {socialLinks.twitter && (
                            <a 
                                href={socialLinks.twitter} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="social-link"
                                title="Twitter"
                            >
                                <TwitterOutlined />
                            </a>
                        )}
                        {socialLinks.linkedin && (
                            <a 
                                href={socialLinks.linkedin} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="social-link"
                                title="LinkedIn"
                            >
                                <LinkedinOutlined />
                            </a>
                        )}
                        {socialLinks.instagram && (
                            <a 
                                href={socialLinks.instagram} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="social-link"
                                title="Instagram"
                            >
                                <InstagramOutlined />
                            </a>
                        )}
                        {socialLinks.youtube && (
                            <a 
                                href={socialLinks.youtube} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="social-link"
                                title="YouTube"
                            >
                                <YoutubeOutlined />
                            </a>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

ClientSupportInfo.propTypes = {
    supportInfo: PropTypes.shape({
        contact_email: PropTypes.string,
        contact_phone: PropTypes.string,
        address: PropTypes.string,
        social_links: PropTypes.shape({
            facebook: PropTypes.string,
            twitter: PropTypes.string,
            linkedin: PropTypes.string,
            instagram: PropTypes.string,
            youtube: PropTypes.string,
        }),
    }),
    darkMode: PropTypes.bool,
};

ClientSupportInfo.defaultProps = {
    supportInfo: null,
    darkMode: false,
};

export default ClientSupportInfo;
